// assets
import {
    CloudUploadOutlined,
    FolderOpenOutlined,
    BookOutlined,
} from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    CloudUploadOutlined,
    FolderOpenOutlined,
    BookOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const cms: NavGroupType = {
    id: 'group-cms',
    title: 'menu.cms.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_core_cms_file_list: {
            id: 'list-files',
            title: 'menu.cms.items.files',
            type: 'item',
            url: '/cms/files',
            icon: icons.FolderOpenOutlined,
            breadcrumbs: false,
        },
        qlive_core_cms_page_pages_list: {
            id: 'list-pages',
            title: 'menu.cms.items.page_list',
            type: 'item',
            icon: icons.BookOutlined,
            url: '/cms/pages',
            breadcrumbs: false,
        },
        qlive_core_cms_file_upload_file: {
            id: 'upload-file',
            title: 'menu.cms.items.file_upload',
            type: 'item',
            icon: icons.CloudUploadOutlined,
            breadcrumbs: false,
            onClick: () => {
                window.dispatchEvent(new Event('cms.open_upload'));
            },
        },
    },
};

export default cms;
